import { useContext } from 'react'

import { AlertContext } from '../AlertContext'

export const useAddAlert = () => {
  const context = useContext(AlertContext)

  if (!context) {
    throw new Error('useAddAlert must be used within AlertProvider')
  }

  return context.addAlert
}
